module.exports = __webpack_public_path__ + "static/media/curvy_underline.a082164f.svg";